interface WhatsNextProps {
  collapsed: boolean
  onToggle: () => void
  onTrackAppeal: () => void
}

export default function WhatsNext({ collapsed, onToggle, onTrackAppeal }: WhatsNextProps) {
  return (
    <div className="mt-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl border border-blue-100 overflow-hidden">
      <button
        onClick={onToggle}
        className="w-full px-4 py-3 flex items-center justify-between text-left hover:bg-blue-100/30 transition-colors"
      >
        <span className="text-sm font-bold text-slate-700">What&apos;s Next?</span>
        <svg className={`w-4 h-4 text-slate-400 transition-transform ${collapsed ? '' : 'rotate-180'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      {!collapsed && (
        <div className="px-4 pb-4 space-y-2.5">
          <div className="flex items-start gap-2.5">
            <span className="text-sm font-semibold text-slate-400 leading-none mt-0.5 w-4 shrink-0">1.</span>
            <p className="text-sm text-slate-700"><span className="font-semibold">Download your letter.</span> Use the <span className="font-medium text-blue-600">Word Doc</span> or <span className="font-medium text-red-500">PDF</span> buttons above to save a copy.</p>
          </div>
          <div className="flex items-start gap-2.5">
            <span className="text-sm font-semibold text-slate-400 leading-none mt-0.5 w-4 shrink-0">2.</span>
            <p className="text-sm text-slate-700"><span className="font-semibold">Add patient information.</span> Open the downloaded file and fill in the [bracketed] fields with patient-specific details.</p>
          </div>
          <div className="flex items-start gap-2.5">
            <span className="text-sm font-semibold text-slate-400 leading-none mt-0.5 w-4 shrink-0">3.</span>
            <p className="text-sm text-slate-700"><span className="font-semibold">Physician review &amp; signature.</span> Have the prescribing physician review all clinical content and sign.</p>
          </div>
          <div className="flex items-start gap-2.5">
            <span className="text-sm font-semibold text-slate-400 leading-none mt-0.5 w-4 shrink-0">4.</span>
            <p className="text-sm text-slate-700"><span className="font-semibold">Submit to payer.</span> Upload to the carrier&apos;s appeals portal, or fax if required.</p>
          </div>
          <div className="flex items-start gap-2.5">
            <span className="text-sm font-semibold text-slate-400 leading-none mt-0.5 w-4 shrink-0">5.</span>
            <div className="flex flex-col sm:flex-row sm:items-center gap-1.5">
              <p className="text-sm text-slate-700"><span className="font-semibold">Track your appeal.</span></p>
              <button
                onClick={onTrackAppeal}
                className="text-xs px-3 py-1.5 rounded-lg bg-teal-500 hover:bg-teal-600 text-white font-semibold transition-all shadow-sm inline-flex items-center gap-1 w-fit"
              >
                Track This Appeal &rarr;
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
